/**
 * Utilitários para Google Tag Manager
 */

// Função para enviar eventos para o GTM
export const sendGTMEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'customEvent',
      eventAction: action,
      eventCategory: category,
      eventLabel: label,
      eventValue: value
    });
  }
};

// Função para rastrear mudanças de página
export const trackPageView = (pagePath, pageTitle) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'page_view',
      page_path: pagePath,
      page_title: pageTitle
    });
  }
};

// Função para inicializar o GTM (se necessário)
export const initializeGTM = (gtmId) => {
  if (typeof window !== 'undefined' && !window.gtmInitialized) {
    // O GTM já está carregado via index.html, então só marcamos como inicializado
    window.gtmInitialized = true;
  }
};